import {COORDINATES_MADRID_3857} from '@/api/util-coordinates';

export default {
  options: {
    type: Object,
    default: () => {
      return {};
    },
  },
  zoom: {
    type: Number,
    default: 2,
  },
  minZoom: {
    type: Number,
    default: 6,
  },
  maxZoom: {
    type: Number,
    default: 13,
  },
  center: {
    type: Array,
    default: () => {
      return COORDINATES_MADRID_3857;
    },
  },
  projection: {
    type: String,
    default: 'EPSG:3857',
  },
  maps: {
    type: Array,
    default: () => {
      return [];
    },
  },
  minimapMaps: {
    type: Array,
    default: () => {
      return [];
    },
  },
  overMaps: {
    type: Array,
    default: () => {
      return [];
    },
  },
  layersGroup: {
    type: Array,
    default: () => {
      return [];
    },
  },
  maxSizePolygonRequest: {
    type: Number,
    default: null,
  },
  warningSizePolygonRequest: {
    type: Number,
    default: null,
  },
  pdf: {
    type: Object,
    default: null,
  },
  coordinatesSystem: {
    type: Array,
    default: () => [],
  },
};
